import React, { useState } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink,  Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { NavLink as RRLink, Link } from 'react-router-dom';
import BALogo from "./BALogo";
import { BettingSites } from "../data";
import './NavMenu.css';


const NavMenu = () => {
    const [collapsed, setCollapsed] = useState(true);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [bettingSites] = useState(BettingSites);


    const toggleNavbar = () => setCollapsed(!collapsed)
    const toggle = () => setDropdownOpen(prevState => !prevState);

    return (
      <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow nav-bar-border title-text nav-bar-ba">
          <Container>
                    <NavbarBrand tag={RRLink} to="/">
                        <div className="header-logo">
                            <div className="header-logo-svg">
                                <BALogo />
                            </div>
                            <div className="header-logo-text footer-text">
                                BonosApuesta.com                          
                            </div>
                            <div className="header-description">
                                Guía segura de apuestas online 
                            </div>
                        </div> 
                    </NavbarBrand>                    


                    <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <NavLink tag={RRLink} to="/apuestasdeportivas">Deportes</NavLink>
                            </NavItem>

                            <NavItem>
                                <NavLink tag={RRLink} to="/casinos">Casino</NavLink>
                            </NavItem>

                            <Dropdown isOpen={dropdownOpen} toggle={toggle} inNavbar={true} nav={true}>
                                <DropdownToggle tag="span"
                                    data-toggle="dropdown"
                                    aria-expanded={dropdownOpen}>
                                    <NavLink>Opiniones</NavLink>
                                </DropdownToggle>
                                <DropdownMenu className="menu-dd" left="true">
                                    {bettingSites.map(b => {
                                        return b.active ?                                      
                                            <DropdownItem tag="span">
                                                <NavLink tag={Link} to={b.reviewUrl}>{b.name}</NavLink>
                                            </DropdownItem>
                                            : <div />
                                        
                                        
                                    })}
                                </DropdownMenu>
                            </Dropdown>
               {/*<NavItem>
                    <NavLink tag={RRLink} to="/bonos">Bonos</NavLink>
                </NavItem>
                <NavItem>
                                <NavLink tag={RRLink} to="/Comparador">Comparador</NavLink>
                </NavItem>*/}
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
}

export default NavMenu;
